import { Currency } from '@/core/currency/interfaces';

const RUB: Currency = {
    name: 'Russian Ruble',
    demonym: 'Russian',
    majorSingle: 'Ruble',
    majorPlural: 'Rubles',
    codeNumeric: '643',
    symbol: '₽',
    symbolNative: '₽',
    minorSingle: 'Kopek',
    minorPlural: 'Kopeks',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'RUB',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default RUB;
